<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="icon__fill"
      d="M7.63124 9.49346C7.3747 9.24637 7.24644 8.9375 7.24644 8.56686C7.24644 8.2689 7.33551 8.00363 7.51366 7.77108C7.69181 7.53125 7.88777 7.34593 8.10154 7.21512C8.32245 7.0843 8.52197 6.92805 8.70012 6.74637C8.87827 6.56468 8.96734 6.37209 8.96734 6.1686C8.96734 5.94331 8.87827 5.75799 8.70012 5.61265C8.5291 5.46003 8.27969 5.38372 7.9519 5.38372C7.36758 5.38372 6.87233 5.63808 6.46615 6.1468L5.75 5.32922C6.3272 4.60974 7.10392 4.25 8.08017 4.25C8.74287 4.25 9.27019 4.40988 9.66211 4.72965C10.054 5.04942 10.25 5.46003 10.25 5.96148C10.25 6.25945 10.1823 6.52834 10.0469 6.76817C9.91865 7.00073 9.75831 7.19331 9.56591 7.34593C9.38064 7.49128 9.19537 7.62936 9.0101 7.76017C8.82482 7.89099 8.66449 8.03634 8.5291 8.19622C8.40083 8.34884 8.3367 8.51236 8.3367 8.68677C8.3367 8.87573 8.41508 9.03924 8.57185 9.17733L7.63124 9.49346ZM8.53979 11.532C8.39727 11.6773 8.22268 11.75 8.01603 11.75C7.80938 11.75 7.63124 11.6773 7.48159 11.532C7.33907 11.3794 7.26781 11.1977 7.26781 10.9869C7.26781 10.7762 7.33907 10.5981 7.48159 10.4528C7.63124 10.3001 7.80938 10.2238 8.01603 10.2238C8.22268 10.2238 8.39727 10.3001 8.53979 10.4528C8.68943 10.5981 8.76425 10.7762 8.76425 10.9869C8.76425 11.1977 8.68943 11.3794 8.53979 11.532Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconHelp",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    // размер
    size: {
      type: String,
      default: "16"
    }
  }
};
</script>
